import React, { useEffect, useState } from 'react';
import { IonCard, IonCardHeader } from '@ionic/react';
import { NavLink } from 'react-router-dom';

import './WacsPage.scss';
import API from '../../../api';
import { WacsProvider } from '../../../models/wacs/WacsProviderResponse';
import { AxiosResponse } from 'axios';

const WacsPage: React.FC = () => {
  const [providers, setProviders] = useState<WacsProvider[]>([]);

  const getProviders = async () => {
    const response: AxiosResponse<WacsProvider[]> = await API.get(
      '/wacs/providers'
    );
    setProviders(response.data);
  };

  useEffect(() => {
    getProviders();
  }, []);

  return (
    <div className="wacs-ctn">
      {providers.map((p) => (
        <>
          <h1>{p.name}</h1>
          <div className="wacs-games-ctn">
            {p.games.map((g) => (
              <IonCard className="wacs-ion-card" key={g.name}>
                <NavLink to={`/wacs/${g.name}`} className="wacs-nav-link">
                  <IonCardHeader className="wacs-card-ctn">
                    <img
                      src={g.image ? g.image.url : ''}
                      alt={g.name}
                      className="wacs-img"
                    />
                  </IonCardHeader>
                </NavLink>
              </IonCard>
            ))}
          </div>
        </>
      ))}
    </div>
  );
};

export default WacsPage;
